import { Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';
import styles from './ArticleDate.module.scss';
import classNames from 'classnames';

export interface ArticleDateProps {
	date: string;
	dateStatus: string;
	className?: string;
}

export const ArticleDate: React.FC<ArticleDateProps> = ({ date, dateStatus, className }) => (
	<Paragraph className={classNames(styles.ArticleDate, className)}>
		{dateStatus} {date}
	</Paragraph>
);
